import {createStyles} from '@mantine/core';
import React from 'react';

import {ScratchPlateViewer} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateViewer';
import useFilledScratchPlateData from 'notebook/integrations/plate-maps/scratch-plates/useFilledScratchPlateData';

const useStyles = createStyles(() => ({
  wrapper: {
    width: '100%',
    height: '100%',
    // PlateMapView sets minWidth inline on the .plate-map SVG, so !important is
    // needed to let the embedded viewer shrink to fit the narrow right sidebar.
    '.plate-map': {
      minWidth: '0 !important',
      width: '100%',
    },
    '.plate-map-legend': {
      width: '100%',
    },
  },
}));

export default function ScratchPlateViewerPane({scratchPlateId}: {scratchPlateId: string}): JSX.Element {
  const {classes} = useStyles();
  const {result} = useFilledScratchPlateData(scratchPlateId);

  return (
    <div className={classes.wrapper}>
      <ScratchPlateViewer result={result} />
    </div>
  );
}
